import { render, staticRenderFns } from "./scoreDialog.vue?vue&type=template&id=142be213&scoped=true&"
import script from "./scoreDialog.vue?vue&type=script&lang=js&"
export * from "./scoreDialog.vue?vue&type=script&lang=js&"
import style0 from "./scoreDialog.vue?vue&type=style&index=0&id=142be213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142be213",
  null
  
)

export default component.exports